// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_3dh9qdIzU-8povNqCMxMDk","marketText":"_24JH0yvUuKQKa6duk-YZx5","customButtonContainer":"_3HuGw9WgyzLUc9jAnh40o1","innerText":"_2VQQ8h-EpIDalnbWg0ikH2","buttonCustomStyle":"_1irvhhVugWfWHYbhsonhgq"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/oddsCard.css
// module id = 339
// module chunks = 0